export const optionSets: Record<string, Record<number, string>> = {
  // --- Account & Contact status ---
  accountStatus: {
    487790000: 'Prospect',
    487790001: 'Active',
    487790002: 'Inactive',
  },
  contactStatus: {
    487790000: 'Prospect',
    487790001: 'Client',
    487790002: 'Departed',
    487790003: 'Deceased',
    487790004: 'Dependant',
  },
  accountType: {
    487790000: 'Personal',
    487790001: 'Corporate',
    487790002: 'Trust',
  },
  title: {
    487790000: 'Mr',
    487790001: 'Mrs',
    487790002: 'Miss',
    487790003: 'Ms',
  },

  // --- Standard Dynamics codes (NOT 487790xxx) ---
  statecode: {
    0: 'Active',
    1: 'Inactive',
  },
  genderCode: {
    1: 'Male',
    2: 'Female',
  },
  familyStatus: {
    1: 'Single',
    2: 'Married',
    3: 'Divorced',
  },
  priorityCode: {
    0: 'Low',
    1: 'Normal',
    2: 'High',
  },

  // --- Generic statuscode (used by leads and other entities) ---
  statuscode: {
    487790000: 'New',
    487790001: 'In Progress',
    487790002: 'Qualified',
  },

  // --- Review status (from response-formatter OPTION_SET_LABELS) ---
  reviewStatus: {
    1: 'Planned',
    2: 'Cancelled (inactive)',
    487790000: 'Current',
    487790001: 'Complete',
    487790002: 'Re-scheduled',
    487790003: 'Declined by client',
    487790004: 'Meeting booked',
    487790005: 'Client uncontactable',
    487790006: 'Cancelled',
  },
  reviewFrequency: {
    487790000: 'Annual',
    487790001: 'Semi-annual',
    487790002: 'Quarterly',
    487790003: 'None',
  },

  // --- Recommendations ---
  recommendationStatus: {
    487790000: 'Drafting advice',
    487790001: 'Advice given',
    487790002: 'Advice accepted',
    487790003: 'Advice implemented',
  },

  // --- Holdings ---
  planStatus: {
    487790000: 'Active',
    487790001: 'Lapsed',
    487790002: 'Closed',
  },

  // --- Tasks ---
  taskStatus: {
    487790000: 'Open',
    487790001: 'In Progress',
    487790002: 'Complete',
  },

  // --- Fees ---
  feeType: {
    487790000: 'Initial',
    487790001: 'Ongoing',
    487790002: 'Ad-hoc',
  },
  frequency: {
    487790000: 'Monthly',
    487790001: 'Quarterly',
    487790002: 'Annual',
    487790003: 'One-off',
  },

  // --- Providers ---
  providerType: {
    487790000: 'Platform',
    487790001: 'Life/Pensions',
    487790002: 'DFM',
  },

  // --- Products ---
  productBasis: {
    487790000: 'Investment',
    487790001: 'Retirement Accumulation',
    487790002: 'Investment Bond',
    487790003: 'Protection',
    487790004: 'Deposit',
  },

  // --- Risk ---
  riskProfile: {
    487790001: 'Cautious',
    487790002: 'Balanced',
    487790003: 'Growth',
    487790004: 'Adventurous',
  },

  // --- Leads ---
  leadSource: {
    487790000: 'Referral',
    487790001: 'Website',
    487790002: 'Event',
    487790003: 'Other',
  },
  leadType: {
    487790000: 'Individual',
    487790001: 'Corporate',
  },

  // --- Planning Objectives ---
  planningPriority: {
    487790000: 'High',
    487790001: 'Medium',
    487790002: 'Low',
  },
  planningObjectiveType: {
    487790000: 'Capital',
    487790001: 'Income',
    487790002: 'Protection',
  },

  // --- Handover Notes (FR-14) ---
  notesReviewed: {
    487790000: 'Not reviewed',
    487790001: 'Reviewed but no requirements',
    487790002: 'Requirements identified',
    487790003: 'Not applicable',
  },
};

export function getOptionSetLabel(optionSetKey: string, value: number): string {
  const optionSet = optionSets[optionSetKey];
  if (!optionSet) return String(value);
  return optionSet[value] ?? String(value);
}
